import { LOAD_BACKGROUNDS } from './../../action-types/backgrounds';

export const STATE_KEY = 'backgrounds';

export const Backgrounds = (state = {}, action) => {
  switch (action.type) {
    case LOAD_BACKGROUNDS: {
      if (action.isSaved) {
        return Object.assign({}, action.backgrounds);
      }

      return [...state, action.backgrounds];
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/backgrounds/backgrounds.js